module.exports = __webpack_public_path__ + "img/logo.8efca398.png";